import { Component, OnInit } from '@angular/core';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-transport',
  templateUrl: './transport.component.html',
  styleUrls: ['./transport.component.css']
})
export class TransportComponent implements OnInit {
  trans: any;

  constructor(private userService:UserService,private route:Router,private modalService: NgbModal,private scrollToService: ScrollToService,) { }

  ngOnInit(): void {
    this.getAllTransport();
    this.triggerScrollTo();
  }

  getAllTransport(){
    this.userService.getallTrasport().subscribe(
        res=>{
          this.trans = res.data;
        }
    )
  }
  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }

  booking(p: any) {
    localStorage.setItem('transport',JSON.stringify(p));
    this.route.navigate(['/index-transport-booking']);
  }
}
